/* ECUALAMA · product-page behaviour for the queen-blanket-us template.
   - Moves the "ECL · Buy box extras" blocks into the Debutify product column.
   - Size cards drive Debutify's own option selectors (so price, URL, variant id,
     sticky add-to-cart and the Rebuy/ATC flow all keep working unchanged).
   - Coverage "choose" buttons, #ecl-* anchors that open accordions, mobile collapse.
   No existing theme file is modified. */
(function () {
  'use strict';
  if (window.EclPdp) { window.EclPdp.init(); return; }

  var MOBILE = 768;

  function mainSection() { return document.querySelector('[data-section-type="product-template"]'); }

  function fire(el) {
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ---- option helpers (Debutify markup: .js-single-option-selector[data-index="optionN"]) ---- */
  function optionControl(ms, index) {
    return ms.querySelector('select.js-single-option-selector[data-index="option' + index + '"]') ||
           ms.querySelector('fieldset .js-single-option-selector[data-index="option' + index + '"]');
  }
  function currentValue(ms, index) {
    var sel = ms.querySelector('select.js-single-option-selector[data-index="option' + index + '"]');
    if (sel) return sel.value;
    var r = ms.querySelector('input.js-single-option-selector[data-index="option' + index + '"]:checked');
    return r ? r.value : null;
  }
  function setValue(ms, index, value) {
    if (currentValue(ms, index) === value) return true;
    var sel = ms.querySelector('select.js-single-option-selector[data-index="option' + index + '"]');
    if (sel) {
      var ok = Array.prototype.some.call(sel.options, function (o) { return o.value === value; });
      if (!ok) return false;
      sel.value = value; fire(sel); return true;
    }
    var radios = ms.querySelectorAll('input.js-single-option-selector[data-index="option' + index + '"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) { radios[i].checked = true; fire(radios[i]); return true; }
    }
    return false;
  }

  /* ---- move buy-box blocks ---- */
  function anchorsFor(ms) {
    var meta = ms.querySelector('.product-single__meta');
    if (!meta) return null;
    var titleBox = null;
    var titles = meta.querySelectorAll('.product-title-container');
    if (titles.length) {
      titleBox = titles[titles.length - 1];
      while (titleBox.parentElement && titleBox.parentElement !== meta) titleBox = titleBox.parentElement;
    }
    var form = meta.querySelector('form[action*="/cart/add"]');
    var price = meta.querySelector('.price-container-desktop') || meta.querySelector('.price-container-wrapper');
    var trust = ms.querySelector('.container-trust_badge');
    var addBox = meta.querySelector('.product-single__add-to-cart');
    var metaList = null;
    var mv = meta.querySelector('.product-single__vendor, .product-single__sku');
    if (mv) metaList = mv.closest('ul');
    return {
      metaList: metaList,
      meta: meta, form: form,
      before_title: titleBox ? { ref: titleBox, where: 'before' } : { ref: meta, where: 'prepend' },
      after_title: titleBox ? { ref: titleBox.nextElementSibling && titleBox.nextElementSibling.querySelector('.review-badge, [class*="review"]') ? titleBox.nextElementSibling : titleBox, where: 'after' } : null,
      after_price: price ? { ref: price, where: 'after' } : null,
      before_options: form ? { ref: form, where: 'prepend' } : null,
      after_button: addBox ? { ref: addBox, where: 'after' } : null,
      after_payments: trust ? { ref: trust, where: 'after' } : (form ? { ref: form, where: 'after' } : null),
      media: ms.querySelector('[id^="ProductMedia-"] .product-single__media-flex-wrapper, [id^="ProductMedia-"] .product-single__media-group, [id^="ProductMedia-"]')
    };
  }

  function place(node, a, last) {
    // keep block order: insert after the previously placed block for the same anchor
    if (last) { last.parentNode.insertBefore(node, last.nextSibling); return; }
    if (a.where === 'before') a.ref.parentNode.insertBefore(node, a.ref);
    else if (a.where === 'after') a.ref.parentNode.insertBefore(node, a.ref.nextSibling);
    else if (a.where === 'prepend') a.ref.insertBefore(node, a.ref.firstChild);
  }

  function mountBuyBox(src) {
    var ms = mainSection();
    if (!ms) return;
    var id = src.getAttribute('data-ecl-bb');
    Array.prototype.forEach.call(document.querySelectorAll('[data-ecl-owner="' + id + '"]'), function (n) { n.remove(); });
    var a = anchorsFor(ms);
    if (!a) return;
    // Blocks are server-rendered in .ecl-bb-items (readable without JS). The first mount moves
    // those nodes; a pristine copy is kept so later re-mounts (theme editor) can clone it.
    var box = src.querySelector('.ecl-bb-items');
    var tpl = src.querySelector('template.ecl-bb-tpl');
    if (!src._eclStore) src._eclStore = box ? box.cloneNode(true) : (tpl ? tpl.content.cloneNode(true) : null);
    if (!src._eclStore) return;
    var nodes;
    if (box && box.children.length && !src._eclMoved) { nodes = Array.prototype.slice.call(box.children); src._eclMoved = true; }
    else nodes = Array.prototype.slice.call(src._eclStore.cloneNode(true).children);
    var lastByAnchor = {};
    nodes.forEach(function (node) {
      var where = node.getAttribute('data-ecl-place') || 'after_payments';
      node.setAttribute('data-ecl-owner', id);
      if (where === 'media') {
        if (a.media) {
          if (getComputedStyle(a.media).position === 'static') a.media.style.position = 'relative';
          a.media.appendChild(node);
        }
        return;
      }
      if (where === 'meta_line') {
        if (a.metaList) {
          if (node.hasAttribute('data-ecl-sku-first')) {
            var sku = a.metaList.querySelector('.product-single__sku');
            var skuLi = sku && sku.closest('li');
            if (skuLi && skuLi.parentNode === a.metaList) a.metaList.insertBefore(skuLi, a.metaList.firstChild);
          }
          a.metaList.appendChild(node);
          return;
        }
        // theme line switched off: show as a plain line above the title
        var wrap = document.createElement('div');
        wrap.className = 'ecl-bb ecl-bb--eyebrow';
        wrap.setAttribute('data-ecl-owner', id);
        wrap.innerHTML = '<p class="ecl-eyebrow"></p>';
        wrap.firstChild.textContent = node.textContent.replace(/\s+/g, ' ').trim();
        node = wrap;
        where = 'before_title';
      }
      var anchor = a[where] || a.after_payments;
      if (!anchor) return;
      place(node, anchor, lastByAnchor[where]);
      lastByAnchor[where] = node;
    });
    src.setAttribute('data-ecl-mounted', 'true');
    document.documentElement.classList.toggle('ecl-hide-arrival', src.getAttribute('data-ecl-hide-arrival') === 'true');
    initCards(ms);
  }

  /* ---- size cards ---- */
  function initCards(ms) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ecl-sizes]'), function (box) {
      var index = box.getAttribute('data-ecl-option-index');
      var name = box.getAttribute('data-ecl-option-name');
      if (!index || index === '0') return;
      if (!optionControl(ms, index)) return; // native picker not found: leave the theme's own selector visible
      // hide only the native row for this option
      Array.prototype.forEach.call(ms.querySelectorAll('.radio-wrapper'), function (w) {
        var lab = w.querySelector('[data-option-name]');
        if (lab && lab.getAttribute('data-option-name') === name) w.classList.add('ecl-native-hidden');
      });
      if (box.__eclBound) return;
      box.__eclBound = true;
      box.addEventListener('click', function (e) {
        var btn = e.target.closest('.ecl-size');
        if (!btn) return;
        setValue(mainSection(), index, btn.getAttribute('data-ecl-value'));
        sync();
      });
    });
    sync();
  }

  function sync() {
    var ms = mainSection();
    if (!ms) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-ecl-sizes]'), function (box) {
      var index = box.getAttribute('data-ecl-option-index');
      var value = currentValue(ms, index);
      if (value == null) return;
      var out = box.querySelector('[data-ecl-choice-out]');
      Array.prototype.forEach.call(box.querySelectorAll('.ecl-size'), function (btn) {
        var on = btn.getAttribute('data-ecl-value') === value;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && out) out.textContent = btn.getAttribute('data-ecl-choice') || '';
      });
    });
  }

  /* sticky add-to-cart select → keep the main picker (and cards) in step */
  function stickyMap() {
    var box = document.querySelector('[data-ecl-sizes][data-ecl-map]');
    if (!box) return null;
    try { return { index: box.getAttribute('data-ecl-option-index'), map: JSON.parse(box.getAttribute('data-ecl-map')) }; } catch (e) { return null; }
  }

  function choose(value) {
    var ms = mainSection();
    var m = stickyMap();
    if (!ms || !m) return;
    setValue(ms, m.index, value);
    sync();
    var meta = ms.querySelector('.product-single__meta') || ms;
    meta.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    var btn = document.querySelector('.ecl-size[aria-pressed="true"]');
    if (btn) btn.focus({ preventScroll: true });
  }

  function openTarget(hash) {
    if (!hash || hash.indexOf('#ecl-') !== 0) return false;
    var el = document.getElementById(hash.slice(1));
    if (!el) return false;
    if (el.tagName === 'DETAILS') el.open = true;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  function collapseOnMobile(root) {
    if (window.innerWidth > MOBILE) return;
    Array.prototype.forEach.call((root || document).querySelectorAll('details[data-ecl-mobile-closed]'), function (d) { d.open = false; });
  }

  // Pages fetched by a proxy (e.g. Glopal's EU domain) are rendered by Shopify for the proxy's own
  // location, often the US. If the page is shown on a different host than it was rendered for,
  // show the non-US versions of market-specific blocks instead of the US ones.
  function fixProxiedMarket() {
    var o = document.querySelector('[data-ecl-origin-host]');
    var host = o && o.getAttribute('data-ecl-origin-host');
    if (!host || location.hostname === host) return;
    document.documentElement.classList.add('ecl-proxied');
    Array.prototype.forEach.call(document.querySelectorAll('[data-ecl-market]'), function (n) {
      n.hidden = n.getAttribute('data-ecl-market') === 'us';
    });
  }

  /* ---- A/B tagging: mark carts built on the new page, so orders can be split by version ---- */
  var TAG_KEY = '_ecl_pdp', TAG_VALUE = 'new', tagTimer = null;
  function tagCart() {
    if (!document.querySelector('[data-ecl-bb]')) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;
        if (cart.attributes && cart.attributes[TAG_KEY] === TAG_VALUE) return;
        var attrs = {}; attrs[TAG_KEY] = TAG_VALUE;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        });
      })
      .catch(function () {});
  }
  function tagSoon() { clearTimeout(tagTimer); tagTimer = setTimeout(tagCart, 1800); }
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('form[action*="/cart/add"] [type="submit"], button[name="add"], [data-ecl-choose], .rebuy-button');
    if (b) tagSoon();
  }, true);
  window.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) tagSoon();
  }, true);

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ecl-bb]'), mountBuyBox);
    if (document.cookie.indexOf('cart=') > -1) tagSoon();
    fixProxiedMarket();
    collapseOnMobile(document);
    sync();
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('.select-sticky_addtocart')) {
      var m = stickyMap();
      if (m && m.map[t.value] != null) setValue(mainSection(), m.index, m.map[t.value]);
    }
    setTimeout(sync, 0);
  });
  window.addEventListener('popstate', function () { setTimeout(sync, 0); });

  document.addEventListener('click', function (e) {
    var v = e.target.closest && e.target.closest('[data-ecl-view]');
    if (v) {
      var sec = v.closest('.ecl-coverage');
      var want = v.getAttribute('data-ecl-view');
      if (sec) {
        Array.prototype.forEach.call(sec.querySelectorAll('[data-ecl-view]'), function (b) { b.setAttribute('aria-selected', b === v ? 'true' : 'false'); });
        Array.prototype.forEach.call(sec.querySelectorAll('[data-ecl-view-panel]'), function (p) { p.hidden = p.getAttribute('data-ecl-view-panel') !== want; });
      }
      return;
    }
    var c = e.target.closest && e.target.closest('[data-ecl-choose]');
    if (c) { e.preventDefault(); choose(c.getAttribute('data-ecl-choose')); return; }
    var a = e.target.closest && e.target.closest('a[href^="#ecl-"]');
    if (a && openTarget(a.getAttribute('href'))) e.preventDefault();
  });

  // Theme editor: re-mount after section reloads (ours or the main product section)
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id) Array.prototype.forEach.call(document.querySelectorAll('[data-ecl-owner="' + id + '"]'), function (n) { n.remove(); });
  });

  window.EclPdp = { init: init, sync: sync, choose: choose };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
